<template>
    <div class="container">
        <div v-if="orderNote" class="ticket">
            <!-- ORIGINAL -->
            <p>
                <br><span id="tipo"></span>
                <span><p>NOTA DE PEDIDO</p></span>
                <span><br>COMPROBANTE NO VALIDO COMO FACTURA</span>
            </p>
            <br>PEDIDO Nro: {{orderNote.number}}
            <br>FECHA: {{ moment().format('DD-MM-YYYY') }}
            <br>HORA: {{ moment().format('HH:mm:SS')  }}
            <br>
    
            <br><strong>PEDIDO:</strong>
            <br>
            <span v-for="value in orderNote.ordernote_details" :key="value.id">
                <br>{{ value.quantity }}X {{ value.description.toUpperCase() }}
                <br>
            </span>
            <br>
        </div>
    
        <button class="btn btn-lg btn-primary" @click="imprimir">Imprimir</button>
        <button class="btn btn-lg btn-outline-primary ml-5" onclick="window.location.href = '/ventas/notas-de-pedido'">Volver</button>
    </div>
    </template>
    
    <script>
    import formatMoneyMixin from "../../mixins/formatMoneyMixin";
    import { mapState } from 'vuex'
    
    export default {
        props: ['orderNoteId'],
        mixins: [formatMoneyMixin],
        data: function() {
        return {
                orderNote: null,
                clientId: null,
            }
        },
        mounted() {
            this.getOrdernote(this.orderNoteId);
        },
        created () {
          this.$store.dispatch('authUser/getAuthUser')
        },
        computed: {
            ...mapState('authUser',{
             authUser: state => state.authUser,
          }),
          totalca () {
                return this.sale.client_accounts.reduce((partialSum, e) => partialSum + e.amount, 0);
            }
        },
        methods: {
            getOrdernote(orderNoteId){
                var vm=this;
                axios.get('/api/ordernotes/getOrdernote/' + orderNoteId)
                .then(response => {
                    if(response.data.success) {
                        vm.orderNote = response.data.data;
                        vm.clientId = response.data.data.client_id;
                    }
                })
                .catch(error => {
                    alert(error);
                })
            },
            imprimir() {
                var ua = navigator.userAgent.toLowerCase();
                var isAndroid = ua.indexOf("android") > -1;
    
                if (isAndroid) {
                    document.getElementById('tipo').innerHTML = 'ORIGINAL';
                    window.print();
                }else{
                    document.getElementById('tipo').innerHTML = 'ORIGINAL';
                    window.print();
                }
            },
        },
        
    }
    </script>
    
    <style>
    * {
        font-size: 12px;
        font-family: Arial, Helvetica, sans-serif;
    }
        
    .ticket {
        color: black;
        background: #fff;
        width: 58mm;
        max-width: 58mm;
        margin: 16px auto;
        padding: 12px;
        border-radius: 6px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }

    @media print {
        .oculto-impresion,
        .oculto-impresion * {
            display: none !important;
            height: 0;
        }

        /* En papel el ticket no lleva margen/sombra: vuelve a ser blanco a sangre. */
        .ticket {
            margin: 0;
            padding: 0;
            border-radius: 0;
            box-shadow: none;
        }
    }
    </style>